export default "__VITE_ASSET__DNWjsbXJ__"